import { changeThemeReducer } from './reducers/changeThemeReducer'
import { createSlice } from '@reduxjs/toolkit'

export interface ThemeState {
    theme: string
}

export const initialState: ThemeState = {
    theme: 'light',
}

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        changeTheme: changeThemeReducer,
    },
})

export const { changeTheme } = themeSlice.actions
export default themeSlice.reducer
